import React from "react";
import { makeStyles, Button, Box } from '@material-ui/core';
import { Formik } from 'formik';
import * as Yup from "yup";
import PropTypes from "prop-types";
import InputTextField from 'components/input/inputTextField';
import SearchableSelect from "../../select/searchableSelect";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: theme.palette.background.paper,
    padding: "16px 0px 8px 0px",
  },
  searchContainer: {
    display: "grid",
    gridTemplateColumns: "4fr 4fr 1fr 1fr",
    columnGap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      gridRowGap: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
  },
  button: {
    [theme.breakpoints.up("sm")]: {
      width: "fit-content",
      justifySelf: "flex-end",
    },
  },
  inputRoot: {
    paddingTop: "8px !important",
    paddingBottom: "7px !important",
  },
}));

function SurveyAnswerSearchComponent({
  handleSearch,
  productDropdown,
  isProductLoading,
  handleItemSearch,
  lang
}) {
  const classes = useStyle();

  return (
    <Box p={2} mb={2} className={classes.mainContainer}>
      <Formik
        initialValues={{
          search: "",
          productSelect: "",
          productName: ""
        }}
        validationSchema={Yup.object({
          search: Yup.string()
        })}
        onSubmit={handleSearch}
        onReset={handleSearch}
      >
        {(formik) => (
          <form className={classes.searchContainer} onSubmit={formik.handleSubmit}>
            <InputTextField
              variant="filled"
              size="small"
              margin="none"
              InputProps={{
                disableUnderline: true,
                margin: "none",
                style: {
                  borderRadius: "4px",
                  backgroundColor: "#eceff0",
                },
                classes: { input: classes.inputRoot }
              }}
              {...formik.getFieldProps("search")}
              error={formik.touched.search && formik.errors.search}
            />
            <SearchableSelect
              placeholder={getLang(lang, 'placeholder.ALL_PRODUCT')}
              handleChange={(value) => {
                formik.setFieldValue("productSelect", value.id)
                formik.setFieldValue("productName", value.name)
              }}
              value={formik.values.productName}
              disabled={false}
              dropdownItem={productDropdown}
              isLoading={isProductLoading}
              emptyMessage={getLang(lang, 'message.info.PRODUCT_NOT_FOUND')}
              searchable={true}
              handleItemSearch={handleItemSearch}
            />
            <Button
              color="secondary"
              variant="text"
              size="small"
              disableElevation
              onClick={formik.handleReset}
            >
              {getLang(lang, 'label.CLEAR')}
            </Button>
            <Button
              variant='contained'
              color='primary'
              disableElevation
              type="submit"
              size="small"
            >
              {getLang(lang, 'label.SEARCH')}
            </Button>
          </form>
        )}
      </Formik>
    </Box>
  );
}

SurveyAnswerSearchComponent.propTypes = {
  handleSearch: PropTypes.func.isRequired
}

export default SurveyAnswerSearchComponent;